module.exports = __webpack_public_path__ + "static/media/modalExampleBgImg1.f04edfe3.png";